export default "__VITE_ASSET__abd0df2a__"